import React, {useEffect, useState} from "react";
import {Button, Form, Input, message, Modal, Radio, Table, Tooltip} from "antd";
import tracks from "../services/track.service";
import {DeleteOutlined, DownloadOutlined} from "@ant-design/icons";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

const {confirm} = Modal;

export const TrackDataList = React.forwardRef((props, ref) => {
    const {t} = useTranslation();
    const [loading, set_loading] = useState(false);
    const [form] = Form.useForm();
    const [data, set_data] = useState([]);
    const [selectionType, setSelectionType] = useState("radio");
    const [selectedRow, setSelectedRow] = useState();
    const [filterTable, setfilterTable] = useState(null);
    const [lastsearch, setLastSearch] = useState(null);
    const {selected} = useParams();

    // columns definition ---------------------------------------------

    const columns =
    [
        {
            title: t('Track.Code'),
            dataIndex: "code",
            key: "code",
        },
        {
            title: t('Track.Discipline'),
            dataIndex: "type",
            key: "type",
        },

        {
            title: t('Track.Site'),
            dataIndex: "venueLabel",
            key: "venueLabel",
            render: (value, record) => (<>{value} ({record.venueCode})</>),
        },
        {
            title: t('Track.Distance'),
            dataIndex: "distance",
            key: "distance",
            render: (value, record) => (<>{value}m</>),
            align: "right",
        },
        {
            title: t('Track.status'),
            dataIndex: "status",
            key: "status",
            render: (value, record) => value,
        },
        {
            title: t('Track.Action_Form'),
            dataIndex: "action",
            key: "action",
            className: "col_action",
            render: (value, record) => {
                return (
                    <>
                        { props.user && props.user.roles && props.user.roles.includes("admin") &&
                            <Tooltip title={t('Track.Delete')}>
                                <Button onClick={(e) => del(e, record.uuid)} shape="circle" icon={<DeleteOutlined/>}/>
                            </Tooltip>
                        }
                        <Tooltip title={t('Track.Download')}>
                            <Button onClick={(e) => download(e, record)} shape="circle" icon={<DownloadOutlined/>}/>
                        </Tooltip>
                    </>
                );
            },
        }

    ];

    // list -----------------------------------------------------------
    const del = async (e, uuid) => {
        e.preventDefault();
        e.stopPropagation();
        confirm({
            title: t('Track.ConfirmDelete'),
            content: t('Track.DeleteDefinitely'),
            onOk()
            {
                return new Promise(async (resolve) =>
                {
                    try
                    {
                        const delResult = await tracks.trackdelete(uuid);

                        if (delResult?.data?.error)
                        {
                            message.error(delResult?.data?.error);
                        }
                        else
                        {
                            message.success(delResult?.data?.message || 'Deleted');
                            const freshData = await list();
                            if (lastsearch)
                            {
                                const filtered = freshData.filter((o) => Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(lastsearch.toLowerCase()))                            );
                                setfilterTable(filtered);
                            }
                        }
                    }
                    catch (error)
                    {
                        message.error("An error occured deleting track");
                    }
                    resolve();
                });
            },
            onCancel() {
            },
        });
    };

    /* -------------------------------------------------------------------------------- *\
    |                               download
    \* -------------------------------------------------------------------------------- */
    const download = async (e, record) =>
    {
        e.preventDefault();
        e.stopPropagation();
        tracks.getContent(record.uuid)
        .then(r =>
        {
            if (!r.data || !r.data.content) return;

            const blob = new Blob([r.data.content], { type: 'text/plain;charset=utf-8' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = record.venueCode + '_' + record.code + '_' + record.type + '_' + record.distance + '_' + record.code + '.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Libérer l'URL après usage
            URL.revokeObjectURL(url);
        })
        .catch(error =>
        {
            console.log(error);
        });
    };


    // load_data ------------------------------------------------------
    const list = async () => {
        return tracks.list()
            .then((r) => {
                if (r.data) {
                    set_data(r.data);
                    return r.data;
                }
                return [];
            })
            .catch((error) => {
                console.log(error);
                return [];
            });
    };

    const rowSelection = {
        onChange: (selectedRowKeys) => {
            setSelectedRow(selectedRowKeys[0]);
        },
        getCheckboxProps: (record) => ({
            disabled: record.name === "Disabled User",
            name: record.name,
        }),
    };

    const searchA = (value) => {
        let filterTable = data.filter((o) =>
            Object.keys(o).some((k) =>
                String(o[k]).toLowerCase().includes(value.toLowerCase())
            )
        );
        setfilterTable(filterTable);
        console.log(value);
        setLastSearch(value);
    };

    // useEffect ------------------------------------------------------

    // first load, init data
    useEffect(() => {
        set_loading(true);
        list().then(() => set_loading(false));
    }, []);

    useEffect(() => {
        if (selectedRow && data) {
            for (let i in data) {
                if (data[i].uuid === selectedRow) {
                    props.trackCallback(data[i].uuid);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRow, data]);

    useEffect(() => {
        if (selected) {
            setSelectedRow(Number(selected));
        }
    }, [selected]);

    // render ---------------------------------------------------------

    return (
        <div className="pdl_wrapper">
            <Form form={form} component={false}>

                <Radio.Group onChange={({target: {value}}) => { setSelectionType(value) }} value={selectionType}/>

                <Input.Search
                    placeholder={t('Track.Search')}
                    enterButton
                    onSearch={searchA}
                    pagination={{pageSize: 20}}
                    className="track_list_search"/>

                <Table
                    rowSelection={{type: selectionType, selectedRowKeys: [selectedRow], ...rowSelection }}
                    bordered
                    columns={columns}
                    dataSource={filterTable === null ? data : filterTable}
                    onSearch={searchA}
                    rowKey="uuid"
                    loading={loading}
                    className="common_list track_list"
                    pagination={{pageSize: 20}}/>

            </Form>
        </div>
    )
})

export default TrackDataList;